import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionTitle = t0 => {
  const $ = _c(28);
  let children;
  let className;
  let props;
  let subtitle;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      subtitle,
      className,
      accentPosition: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = subtitle;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    subtitle = $[4];
    t1 = $[5];
  }
  const accentPosition = t1 === undefined ? "left" : t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("mb-6", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = accentPosition === "left" ? "pl-4" : "pb-2";
  let t4;
  if ($[8] !== t3) {
    t4 = cn("text-2xl font-bold md:text-3xl", t3);
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== accentPosition) {
    t5 = accentPosition === "left" && /*#__PURE__*/_jsx("div", {
      className: "bg-branding absolute left-0 top-0 h-full w-1"
    });
    $[10] = accentPosition;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== accentPosition) {
    t6 = accentPosition === "bottom" && /*#__PURE__*/_jsx("div", {
      className: "bg-branding absolute bottom-0 left-0 h-1 w-24"
    });
    $[12] = accentPosition;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== children || $[15] !== props || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = /*#__PURE__*/_jsxs("h2", {
      className: t4,
      ...props,
      children: [children, t5, t6]
    });
    $[14] = children;
    $[15] = props;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== subtitle) {
    t8 = subtitle && /*#__PURE__*/_jsx("p", {
      className: "mt-1 text-sm text-muted-foreground",
      children: subtitle
    });
    $[20] = subtitle;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t7, t8]
    });
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t2 || $[26] !== t9) {
    t10 = /*#__PURE__*/_jsx("div", {
      className: t2,
      children: t9
    });
    $[25] = t2;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};